import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { WaiterHttpService } from "src/app/share-modul/services/common/waiter-http-service";
import { environment } from "src/environments/environment";
import {OrderModel} from "../../models/orders/order.model";
import {SplitBillModel} from "../../models/orders/split-bill-model.model";
import {DeleteOrderBillModel} from "../../models/orders/delete-order-bill.model";
import {DeleteOrderBillItemModel} from "../../models/orders/delete-order-bill-item.model";
import {BillReadyForPrintModel} from "../../models/orders/bill-ready-for-print.model";
import {PayBillModel} from "../../models/orders/pay-bill.model";

const WTR_MENU_API = environment.apiURL + '/api/wtr/OrderBill/';

@Injectable({
  providedIn: 'root'
})

export class OrderService {

  constructor(private _waiterHttpService: WaiterHttpService) {
  }

  addOrder(model: OrderModel){
    let url = WTR_MENU_API + 'addorder';
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  listOrderBillsForWaiterAndVenue(employeeId: string, venueId: string) {
    var url = WTR_MENU_API + "listorderbills?EmployeeId=" + employeeId + "&VenueId=" + venueId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listOrderBillsSimple(employeeId: string, venueId: string) {
    var url = WTR_MENU_API + "listorderbillssimple?EmployeeId=" + employeeId + "&VenueId=" + venueId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  viewOrderBillForTable(tableId: string) {
    var url = WTR_MENU_API + "vieworderbillfortable?TableId=" + tableId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  splitOrderBill(model: SplitBillModel) {
    var url = WTR_MENU_API + "splitorderbill";
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteOrderBill(model: DeleteOrderBillModel) {
    var url = WTR_MENU_API + "deleteorderbill";
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }
  deleteOrderBillItem(model: DeleteOrderBillItemModel) {
    var url = WTR_MENU_API + "deleteorderbillitem";
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  printBillThermalPrinter(model: BillReadyForPrintModel) {
    var url = WTR_MENU_API + "setorderbillasreadyforclose";
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  printBillTFiscalPrinter(model: BillReadyForPrintModel) {
    var url = WTR_MENU_API + "setorderbillasreadyforprint";
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  payBill(model: PayBillModel) {
    var url = WTR_MENU_API + "setorderbillaspayed";
    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }


}
